'use client';
import { DayPicker, getDefaultClassNames } from 'react-day-picker';
import { useState } from 'react';
import { format } from 'date-fns';
import { frCA } from 'react-day-picker/locale';
import 'react-day-picker/dist/style.css';
import { useClientTranslation } from '../data/utils/useClientTranslation';
import { FormField } from '../data/dataType';

interface CustomDatePickerProps {
    dataField: FormField;
    locale: string;
    onChange: (date: Date | string | null) => void;
}

export const CustomDatePicker: React.FC<CustomDatePickerProps> = ({
    dataField: { name },
    onChange,
    locale,
}) => {
    const [value, setValue] = useState<Date | null>(null);
    const [isOpen, setIsOpen] = useState(false);
    const { translation } = useClientTranslation(locale, 'fieldsInput');

    const handleDateSelect = (date: Date | undefined) => {
        setValue(date || null);
        onChange(date ? format(date, 'yyyy-MM-dd') : null);
        setIsOpen(false);
    };

    return (
        <div className="relative w-full">
            <input
                className="w-full p-2 border rounded-md focus:ring focus:ring-primary cursor-pointer"
                id={name}
                onClick={() => setIsOpen(!isOpen)}
                placeholder={
                    translation?.datePlaceholder || 'Sélectionner une date'
                }
                readOnly
                type="text"
                value={value ? format(value, 'yyyy-MM-dd') : ''}
            />

            {isOpen && (
                <div className="absolute z-10 w-100 bg-white border rounded-lg shadow-lg mt-2">
                    <DayPicker
                        classNames={{
                            today: 'border border-primary text-primary rounded-md',
                            selected: 'bg-primary text-white rounded-md',
                            root: `${getDefaultClassNames().root} shadow-lg p-5`,
                            chevron: 'fill-primary',
                        }}
                        locale={frCA}
                        mode="single"
                        onSelect={handleDateSelect}
                        selected={value || undefined}
                    />
                </div>
            )}
        </div>
    );
};
